import React from 'react'
import _ from 'lodash'
import immutable from 'immutable'

import {RelatedAccommodation} from '../widgets/relatedcontentband/relatedaccommodation.component'

export class AccommodationSearchResults extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        var accommodations = this.props.accommodations.map(function(acc, i) {
            let _accom = new immutable.fromJS(acc)
		    return <RelatedAccommodation
        {...this.props}
        key={i}
        item={ _accom } 		    		
        showDetails = { () => { this.props.activateSearchItem(_accom) } }
        addToItin = { () => { this.props.onSelectAccommodation(this.props.leg, _accom, this.props.user) } }
        removeFromItin = { () => { this.props.onRemoveAccommodation(this.props.leg, _accom, this.props.user) } } 
        model="accommodation"/>
        }, this)

        return (
            <div className="related-content-items">{accommodations}</div>
        )
    }
}
